<template>
  <ValidationProvider :vid="vid" :name="$attrs.name" :rules="rules">
    <b-form-group slot-scope="{ valid, errors }" v-bind="$attrs">
      <template #label>
        <label>
          {{ $attrs.label }}
          <span v-if="$attrs.required || rules.includes('required')" class="text-danger font-bold"
            >*</span
          >
        </label>
      </template>
      <v-select
        v-model="selectedItemGroup"
        :options="itemGroupOptions"
        :placeholder="$attrs.placeholder || 'Select Item Group'"
        :loading="loadingItemGroups || loadingSelectedItemGroup"
        :clearable="true"
        :class="!!errors[0] ? 'is-invalid' : ''"
        @search="onSearch"
        @input="handleInput"
        :disabled="$attrs.disabled"
        :state="errors[0] ? false : rules && rules.includes('required') && valid ? true : null"
        v-bind="$attrs"
      >
        <template #no-options>
          <div class="text-center text-muted">No ItemGroups found</div>
        </template>

        <template #spinner="{ loading }">
          <div v-if="loading" class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </template>

        <template #selected-option="{ id, name }">
          <span class="text-muted mr-1 border-right pr-1">{{ id }}</span>
          <strong>{{ name }}</strong>
        </template>

        <template #option="{ id, name }">
          <b-row>
            <div class="d-flex flex-column pr-1 mr-1 border-right">
              <small class="text-muted d-block">ID</small>
              <strong>{{ id }}</strong>
            </div>
            <div class="d-flex flex-column">
              <small class="text-muted d-block">NAME</small>
              <strong class="mr-1">{{ name }}</strong>
            </div>
          </b-row>
        </template>
      </v-select>

      <b-form-invalid-feedback id="inputLiveFeedback">
        {{ errors[0] ? errors[0].replace('{field}', $attrs.label) : '' }}
      </b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import { BFormGroup, BFormInvalidFeedback } from 'bootstrap-vue';
import { api } from '@/utils/api';
import { BCol, BRow } from 'bootstrap-vue';
import { ValidationProvider } from 'vee-validate';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'ItemGroupDropdownField',
  components: {
    ValidationProvider,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormInvalidFeedback,
  },
  props: {
    vid: {
      type: String,
    },
    name: {
      type: String,
      default: 'ItemGroup',
    },
    value: {
      type: [Object, Number, String],
      default: () => null,
    },
    rules: {
      type: [Object, String],
      default: '',
    },
  },
  data() {
    return {
      searchTerm: '',
      pageNumber: 1,
      loadingItemGroups: false,
      loadingSelectedItemGroup: false,
      itemGroupOptions: [],
      selectedItemGroup: null,
      // Add debounce timer for search
      searchTimeout: null,
    };
  },
  computed: {
    businessID() {
      return this.$store.state.user?.businessID;
    },
  },
  created() {
    const itemGroupId = this.value;

    if (itemGroupId) {
      this.loadingSelectedItemGroup = true;
    } else {
    }

    this.fetchItemGroups()
      .then((options) => {
        if (itemGroupId) {
          this.selectedItemGroup = options.find((opt) => opt.id === itemGroupId);
        }
      })
      .finally(() => {
        this.loadingSelectedItemGroup = false;
      });
  },
  methods: {
    async fetchItemGroups() {
      this.loadingItemGroups = true;
      try {
        const response = await api.get(`/ItemGroups/GetByPagination/${this.businessID}`, {
          params: {
            searchTerm: this.searchTerm,
            pageNumber: this.pageNumber,
            pageSize: 9999,
          },
        });

        if (
          response.data &&
          response.data.status === 'success' &&
          response.data.data &&
          response.data.data.items
        ) {
          this.itemGroupOptions = [...response.data.data.items];

          return [...this.itemGroupOptions];
        } else {
          console.error(
            '=== ItemGroupDropdownField options Error in paginated itemGroup data format:',
            response.data
          );
        }
      } catch (error) {
        console.error('=== ItemGroupDropdownField options Error fetching itemGroups:', error);
      } finally {
        this.loadingItemGroups = false;
      }

      return [];
    },

    onSearch(searchTerm) {
      // Debounce search like SalesOrderDropdown.vue
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTerm = searchTerm;
      if (!searchTerm || searchTerm.trim() === '') {
        this.searchTerm = '';
        this.fetchItemGroups();
        return;
      }
      this.searchTimeout = setTimeout(() => {
        this.fetchItemGroups();
      }, 300);
    },

    handleInput(value) {
      this.selectedItemGroup = value;
      this.$emit('input', value);
    },
  },
  watch: {
    selectedItemGroup: {
      async handler(newVal) {
        this.$emit('input', newVal?.id);
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
};
</script>

<style lang="scss" scoped>
.v-select {
  &.is-invalid {
    .vs__dropdown-toggle {
      border-color: #dc3545;
    }
  }

  .vs__selected {
    width: 100%;
  }

  ::v-deep {
    .vs__dropdown-menu {
      max-height: 350px;
    }
  }
}
</style>
